import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./AtelierInfoFirst.css";

class AtelierInfoFirst extends Component {
  render() {
    const { data, language } = this.props;
    return (
      <div className="AtelierInfoFirst">
        <div className="AtelierInfoFirst-text">{data.text[language]}</div>
        <div className="AtelierInfoFirst-content">
          <div className="AtelierLatestFSBorder" />
          <h4 className="LatestTitle">{data.title[language]}</h4>
          <span className="AtelierLatestSubTitle">
            {data.subtitle[language]}
          </span>
          <p className="LatestDesc">{data.description[language]}</p>
        </div>
        <div className="AtelierVideo">
            <video
              width="100%"
              src={data.video}
              autoPlay={true}
              controls={false}
              loop={true}
              muted={true}
            />
            <div className='BackgroundAtelier'></div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default withRouter(connect(mapStateToProps)(AtelierInfoFirst));



// WEBPACK FOOTER //
// ./src/components/AtelierInfo/AtelierInfoFirst/index.js